import { Navigate } from "react-router-dom";
import { getSecureItem } from "./utils/LocalStorageManager";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const hasToken = !!getSecureItem("access_token");
  return hasToken ? <>{children}</> : <Navigate to="/" replace />;
};